var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1372 2.96102L7.10719 5.96102C1.03719 7.99102 1.03719 11.301 7.10719 13.321L9.78719 14.211L10.6772 16.891C12.6972 22.961 16.0172 22.961 18.0372 16.891L21.0472 7.87102C22.3872 3.82102 20.1872 1.61102 16.1372 2.96102ZM16.4572 8.34102L12.6572 12.161C12.5072 12.311 12.3172 12.381 12.1272 12.381C11.9372 12.381 11.7472 12.311 11.5972 12.161C11.3072 11.871 11.3072 11.391 11.5972 11.101L15.3972 7.28102C15.6872 6.99102 16.1672 6.99102 16.4572 7.28102C16.7472 7.57102 16.7472 8.05102 16.4572 8.34102Z",
    fill: "#007094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.c3d861177bb7f521e7c25fae95a117c8.svg";
export { ForwardRef as ReactComponent };